import { VERIFY_OTP } from "../actionTypes";

export function verifyOtp(data) {
  return {
    type: VERIFY_OTP,
    data
  };
}